<div class="ui basic segment">

    <footer>
        <p class="center-text">&copy; Symposium Technologies Inc. {{year}}
            <a target="_blank" href="https://www.sinirji.com/docs/terms_of_service">Terms of Service</a>&nbsp;|&nbsp;
            <a target="_blank" href="https://www.sinirji.com/docs/privacy_policy">Privacy Policy</a>&nbsp;|&nbsp;
            <a target="_blank" href="https://www.sinirji.com/docs/use_of_cookies">Use of Cookies</a>
        </p>
        <p class="center-text">Powered by the &copy; Sinirji Platform</p>
    </footer>

</div>


// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.html